// frontend/src/services/contractService.js
// frontend/src/services/contractService.js = Phase 8 Contracts API client for the UPS-admin permission plane.
// Centralizes all HTTP calls to /ups-admin/contracts endpoints (list/create contracts, toggle contract status, fetch site permissions, toggle contract-site status) and returns backend-shaped payloads for Redux thunks.
// Phase 8: Contracts API client (UPS-admin permission plane)

import axios from 'axios';

const BASE = '/ups-admin/contracts';

// List all contracts for the current company (UPS-admin only).
export async function fetchContractsApi() {
  const { data } = await axios.get(BASE);
  return data; // { contracts: [...] }
}

export async function createContractApi({ agencyId }) {
  const { data } = await axios.post(BASE, { agencyId });
  return data; // { contract: {...} }
}

export async function setContractStatusApi(contractId, status) {
  const { data } = await axios.patch(`${BASE}/${contractId}`, { status }); // 'active' | 'disabled'
  return data; // { contract: {...} }
}

export async function fetchContractSitesApi(contractId) {
  const { data } = await axios.get(`${BASE}/${contractId}/sites`);
  return data; // { sites: [...] }
}

export async function setContractSiteStatusApi(contractId, siteId, status) {
  const { data } = await axios.patch(`${BASE}/${contractId}/sites/${siteId}`, { status });
  return data; // { contract_site: {...} }
}
